import React, { useEffect, useRef } from "react";


import { UserContext } from "../../UserContext";
import axios from 'axios'


import FilterTable from "pages/Dashboard/Tables/Admin/FilterTable";
function AllAdmin() {

    const{auth,user} = React.useContext(UserContext)
    const[users, setUsers] =  React.useState([]);
  
    React.useEffect( () => {
    
      if (auth != null) {
        if (!auth) {
          window.location.href="/login"
        }else{
          getUsers(user.user)
        }
      }
    }, [auth])

    const getUsers = async(info) => {
        const userData = {
            info: info,
          }
      
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}get-all-admin`,userData).then((res)=>{
      
            if(res.data.status == 200)
            {
                setUsers(res.data.users)
              
            }
      
          })
    }

  return (
    <div>
        <FilterTable users={users} />
    </div>
  )
}

export default AllAdmin